"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTokenRefreshError = exports.hasRefreshTokenError = void 0;
const signOut_1 = require("../signOut");
/**
 * A function to determine if the session has a token refresh error
 * @param session A next-auth session or null
 * @returns true if the session has a token refresh error, false otherwise
 */
const hasRefreshTokenError = (session) => session?.error === 'RefreshAccessTokenError';
exports.hasRefreshTokenError = hasRefreshTokenError;
/**
 * A client-side only function to handle expired tokens.
 * @param session A next-auth session
 * @param allowExpiredToken Deprecated
 * @returns The next-auth session or null if the token is expired
 */
const handleTokenRefreshError = (session, allowExpiredToken) => {
    if (!allowExpiredToken) {
        // eslint-disable-next-line no-console
        console.warn(session?.user?.loginEmail, 'Session contains expired Okta token that could not be refreshed.');
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            if (!params.has('destination')) {
                params.set('destination', window.location.pathname);
            }
            params.set('reason', 'expired');
            // we need to remove the next-auth cookies so the session is cleared
            // but also redirect to the logout page so that firebase is cleared too
            (0, signOut_1.signOut)({ callbackUrl: `/identity/logout?${params.toString()}` });
        }
        // we return null here so the UI renders as if the user is not logged in
        // while we redirect them to the logout page
        return null;
    }
    return session;
};
exports.handleTokenRefreshError = handleTokenRefreshError;
